<template>
	<div class="dt-companies-filter-item flex max-w-[192px] flex-col">
		<el-dropdown popper-class="dt-companies-dropdown-filter" trigger="click" :hide-on-click="false" placement="bottom-start">
			<span class="el-dropdown-link flex h-10 w-full items-center gap-x-2 rounded-[5px] border border-solid border-dark_cyan px-3 py-1.5 font-roboto font-medium text-night_rider">
				<span class="block flex-1 truncate">
					<small v-if="filter.selectedSectors.length"> {{ filter.selectedSectors.length }} </small>
					Industry
				</span>
				<el-icon class="el-icon--right !ml-0">
					<arrow-down />
				</el-icon>
			</span>
			<template #dropdown>
				<el-dropdown-menu>
					<el-dropdown-item>
						<div class="dropdown-search">
							<el-input v-model="industrySearch" placeholder="Search">
								<template #prefix>
									<el-icon>
										<SearchIcon />
									</el-icon>
								</template>
							</el-input>
						</div>
					</el-dropdown-item>
					<el-dropdown-item class="d-flex flex-column align-items-start dropdown-search-item">
						<el-checkbox-group v-model="filter.selectedSectors" @change="onChange" :max="3">
							<el-checkbox v-for="sector in props.sectors" :key="sector.id" :label="sector.name" :value="sector.id" />
						</el-checkbox-group>
					</el-dropdown-item>
				</el-dropdown-menu>
			</template>
		</el-dropdown>
	</div>
</template>

<script setup lang="js">
import SearchIcon from "@/components/Svg/SearchIcon.vue";
import filter from "@/pages/Company/filter";
import { ArrowDown } from "@element-plus/icons-vue";
import { ref } from "vue";

const props = defineProps({
	sectors: { type: Array, default: () => [] },
});

const industrySearch = ref("");

const selectedSectors = ref([]);

const onChange = () => {
	filter.value.reload++;
};
</script>
